import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { applyPwaSurface, resolvePwaSurface } from './registerPwa'

/** Keep manifest/theme aligned with the active app surface. */
export function PwaRouteSync() {
  const { pathname } = useLocation()
  useEffect(() => {
    applyPwaSurface(resolvePwaSurface(pathname))
  }, [pathname])
  return null
}
